import axiosClient from './axiosClient'

const miscApi = {
  findByLookupCode: (lookupCode) =>
    axiosClient.get(`/misc/find-by-lookup-code?lookupCode=${encodeURIComponent(lookupCode)}`),
  exportLookupCode: (token) =>
    axiosClient.get(`/misc/export-by-lookup-code?token=${encodeURIComponent(token)}`, {
      responseType: 'blob',
    }),
  xmlByToken: (token) =>
    axiosClient.get(`/misc/xml-by-token?token=${encodeURIComponent(token)}`),
}

export default miscApi
